module.exports = __webpack_public_path__ + "img/6.d1d891d4.png";